
      var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDevice = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 51,
  height: 50,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 39,
  width: 34,
  height: 22,
  rx: 2.75,
  transform: "rotate(-90 11 39)",
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 33.2,
  r: 2.2,
  transform: "rotate(-180 22 33.2)",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"51\" height=\"50\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect x=\"11\" y=\"39\" width=\"34\" height=\"22\" rx=\"2.75\" transform=\"rotate(-90 11 39)\" stroke=\"#000\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"22\" cy=\"33.2\" r=\"2.2\" transform=\"rotate(-180 22 33.2)\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/device.7726260b21525eddd8794cfe24f74147.svg"),
        {
          React: SvgDevice,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      